import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import RefreshIcon from '@material-ui/icons/Autorenew';
import SendIcon from '@material-ui/icons/Send';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { TABLE_HEADER_COLOR, MKS_REQUEST_STATUSES_PARAMETERS, MKS_REQUEST_STATUSES, GREEN } from '../../_config/consts';
import { getColorFromThemeName } from '../../_config/utils';
import EmptyView from '../EmptyView.jsx';
import ListLoadingView from '../ListLoadingView.jsx';
import MDTablePaginationActions from '../MDTable/MDTablePaginationActions.jsx';

const styles = theme => ({
  table: {
    overflow: 'scroll',
  },
  tableColumnText: {
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  disabledInput: {
    display: 'none',
  },
  rowSelected: {
    backgroundColor: 'aliceblue !important',
    color: 'aliceblue !important',
  },
  rowHovered: {
    cursor: 'pointer',
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
    minHeight: 60,
  },
  paginationText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  statusBadge: {
    padding: '4px 12px',
    borderRadius: 12,
    fontSize: 12,
    fontWeight: 'bold',
    display: 'inline-block',
    textAlign: 'center',
    minWidth: 100,
  },
  button: {
    color: GREEN,
    fontSize: 12,
    fontWeight: 'bold',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'rgba(76, 175, 80, 0.08)',
    },
  },
  actionContainer: {
    display: 'flex',
    alignItems: 'center',
  },
});

@connect((state) => ({ 
  viewLoading: state.utils.viewLoading, 
  mks: state.mks, 
  themeName: state.settings.items.theme.data.themeName 
}))
class MksRequestsTableView extends React.Component {

  render() {
    const {
      classes,
      viewLoading,
      themeName,
      mks: { mksRequests: { data: requestsData } },
      onRefreshRequests,
      onFetchRequestsOnPage,
      onSelectRequest,
      onSendRequest,
    } = this.props;

    const requestsContent = requestsData && requestsData.content ? requestsData.content : [];
    const pagination = requestsData && !_.isEmpty(requestsData) ? _.omit(requestsData, 'content') : {};
    const { number: currentPage = 0, size = 0, totalPages = 0, totalElements = 0 } = pagination;

    const headerColor = getColorFromThemeName(themeName);
    
    return (
      <div className="list-view details-section" style={{ top: 150, paddingBottom: 140, width: '87%' }}>
        <div>
          {!_.isEmpty(requestsContent) ?
            <Card style={{ overflow: 'scroll' }} elevation={4}>
              <Table size="small" className={classes.table}>
                <TableHead>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TableCell colSpan={2}>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <h3 className={classes.tableColumnText} style={{ color: '#3f3f3f', marginTop: 15, marginBottom: 15 }}>
                          <Entity entity="mksRequests" />
                        </h3>
                        <IconButton onClick={() => onRefreshRequests()} style={{ marginLeft: 10, marginTop: 5 }}>
                          <RefreshIcon style={{ color: '#3f3f3f', fontSize: 25 }} />
                        </IconButton>
                      </div>
                    </TableCell>
                    <TablePagination
                      colSpan={0}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="mksRequestsTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchRequestsOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          iconColor="#3f3f3f"
                          page={currentPage}
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchRequestsOnPage(page)}
                        />
                      )}
                    />
                  </TableRow>
                  <TableRow style={{ backgroundColor: 'white' }}>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="id" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="requestType" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="createdBy" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="status" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="deliveryDate" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="actions" /></h4></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {_.map(requestsContent, (request) => {
                    const statusParams = request.status && MKS_REQUEST_STATUSES_PARAMETERS[request.status] 
                      ? MKS_REQUEST_STATUSES_PARAMETERS[request.status] 
                      : null;
                    const isDraft = request.status === MKS_REQUEST_STATUSES.DRAFT;
                    
                    return (
                      <TableRow
                        key={request.id}
                        className={classes.row}
                        hover
                        classes={{
                          selected: classes.rowSelected,
                          hover: classes.rowHovered,
                        }}
                      >
                        <TableCell onClick={event => onSelectRequest && onSelectRequest(request)}>
                          <h5 style={{ fontWeight: 'bold', fontSize: 14 }}>{request.id || '---'}</h5>
                        </TableCell>
                        <TableCell onClick={event => onSelectRequest && onSelectRequest(request)}>
                          <h5 style={{ fontSize: 14 }}>{<Entity entity={request.requestType} /> || '---'}</h5>
                        </TableCell>
                        <TableCell onClick={event => onSelectRequest && onSelectRequest(request)}>
                          <h5 style={{ fontSize: 14 }}>{request.createdBy || '---'}</h5>
                        </TableCell>
                        <TableCell onClick={event => onSelectRequest && onSelectRequest(request)}>
                          {statusParams ? (
                            <span 
                              className={classes.statusBadge}
                              style={{ 
                                backgroundColor: statusParams.backgroundColor,
                                color: statusParams.textColor,
                              }}
                            >
                              {<Entity key={statusParams.string} entity={statusParams.string} /> || '---'}
                            </span>
                          ) : (
                            <h5 style={{ fontSize: 14 }}>{request.status || '---'}</h5>
                          )}
                        </TableCell>
                        <TableCell onClick={event => onSelectRequest && onSelectRequest(request)}>
                          <h5 style={{ fontSize: 14 }}>
                            {request.deliveryDate ? moment(request.deliveryDate).format('DD MMM YYYY') : '---'}
                          </h5>
                        </TableCell>
                        <TableCell>
                          {isDraft && (
                            <div className={classes.actionContainer} style={{ justifyContent: 'flex-start', marginLeft: -15 }}>
                              <Button
                                onClick={(event) => {
                                  event.stopPropagation();
                                  onSendRequest && onSendRequest(request);
                                }}
                                className={classes.button}
                              >
                                <Entity entity="sendNow" />
                                <SendIcon style={{ fontSize: 20, marginLeft: 5 }} />
                              </Button>
                            </div>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                <TableFooter>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TablePagination
                      colSpan={0}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="mksRequestsTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchRequestsOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          page={currentPage}
                          iconColor="#3f3f3f"
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchRequestsOnPage(page)}
                        />
                      )}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </Card>
            : (
              <div>
                {!viewLoading ? (
                  <EmptyView
                    title="noMksRequests"
                    subtitle="noMksRequestsSubtitle"
                    iconName="icon-simple-line-icons-docs"
                  />
                ) : <ListLoadingView />}
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(MksRequestsTableView);

